import { OnboardingStepProps } from '../types';

import VsimavecHead from '../../../assets/vsimavec-head.svg';
import { Button } from '../../buttons/Button';
import { Video } from '../Video';

export function StepIntroVideo({ onNext, category }: OnboardingStepProps) {
    return (
        <>
            {/* Header */}
            <div className="text-center">
                <div className="mx-auto mb-6 w-20">
                    <img
                        src={VsimavecHead}
                        alt="Logo"
                        className="h-full w-full object-contain"
                    />
                </div>
                <h1 className="text-5xl">Vítejte ve Všímavci!</h1>
                <p className="mb-6 text-ink-800">
                    Objevte, kdo jsme a v čem vám můžeme pomoci.
                </p>
            </div>

            {/* Video */}
            <div className='flex-1 w-full max-w-[892px]'>
              <h2 className='text-2xl'>
                Úvodní video: Proč zařadit Všímavce?
              </h2>
                <Video slug="uvitaci-video" category={category} />
            </div>

            {/* Button */}
            <div className="flex w-full max-w-[540px] flex-col gap-2">
                <Button
                    color="product"
                    className="text-base"
                    onClick={() => onNext('how-we-help')}
                    // className="bg-product-500 hover:bg-product-600 text-white font-bold text-[20px] w-[545px] h-[45px] rounded-[12px] transition-colors"
                >
                    Pokračovat
                </Button>
            </div>
        </>
    );
}
